import { cn } from "@/lib/utils";

const INCORPORATION_YEAR = 2025;

interface AppFooterProps {
  className?: string;
}

export function getCopyrightYear(currentYear = new Date().getFullYear()) {
  return currentYear <= INCORPORATION_YEAR
    ? `${INCORPORATION_YEAR}`
    : `${INCORPORATION_YEAR}\u2013${currentYear}`;
}

export function AppFooter({ className }: AppFooterProps) {
  return (
    <footer
      className={cn(
        "mt-12 w-full px-4 pb-6 pt-6 text-center text-xs leading-5 text-muted-foreground sm:mt-16 sm:pb-8",
        className,
      )}
    >
      <p>© {getCopyrightYear()} TransportMate Ltd. All rights reserved.</p>
      <p>Company No. 16988791</p>
    </footer>
  );
}